
import { Sine, TweenLite, TweenMax, Linear } from 'gsap/all'
import 'gsap/CSSPlugin'
import { defineComponent, onMounted } from 'vue'

export default defineComponent({
  name: 'Sakura',
  setup() {

    onMounted(() => {
      startSakura()
    })

    function startSakura() {
      const total = 40
      const container = document.getElementById('particle-container')
      const w = window.innerWidth

      for (let i = 0; i < total; i++) {
        var Div = document.createElement('div')
        TweenLite.set(Div, { attr: { class: 'dot' }, x: R(0, w), y: R(-200, -150), z: R(-200, 200) })
        container!.appendChild(Div)
        animm(Div)
      }
    }

    function animm(elm: any) {
      const h = window.innerHeight
      TweenMax.to(elm, R(6, 15), { x: '+=100', y: h + 100, ease: Linear.easeNone, repeat: -1, delay: -15 })
      TweenMax.to(elm, R(4, 8), { x: '+=500', rotationZ: R(0, 180), repeat: -1, yoyo: true, ease: Sine.easeInOut })
      TweenMax.to(elm, R(2, 8), { x: '+=200', rotationX: R(0, 360), rotationY: R(0, 360), repeat: -1, yoyo: true, ease: Sine.easeInOut, delay: -5 })
    }

    function R(min, max) {
      return min + Math.random() * (max - min)
    }

    return {
    }
  }
})
